import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {FulfillmentFilterPayloadModel} from "../../../models/fulfillment-filter-payload.model";
import {PaginatedResultModel} from "../../../../commons/angular/models/paginated-result.model";
import {FulfillmentModel} from "../../../models/fulfillment.model";

export const FulfillmentChannelActions = createActionGroup({
  source: '[Fulfillment/Channel]',
  events: {
    subscribe: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: FulfillmentModel }>(),
  }
});

export const FulfillmentAPiActions = createActionGroup({
  source: '[Fulfillment/API]',
  events: {

    //Get single fulfillment
    getFulfillment: props<{ fulfillmentId: string, expand?: boolean }>(),
    getFulfillmentSuccess: props<{ fulfillment: FulfillmentModel }>(),
    getFulfillmentFailure: props<{ error: any }>(),

    //Get Fulfillments Pagination Result
    getFulfillmentsPaginatedResult: props<{ page: number, size: number, payload: FulfillmentFilterPayloadModel }>(),
    getFulfillmentsPaginatedResultSuccess: props<{ paginatedResult: PaginatedResultModel<FulfillmentModel> }>(),
    getFulfillmentsPaginatedResultFailure: props<{ error: any }>()

  }
});

export const FulfillmentActions = createActionGroup({
  source: '[Fulfillment]',
  events: {
    removeAll: emptyProps()
  }
});

